import { createSlice } from '@reduxjs/toolkit';
export const CommonStoreKey = 'CommonStore';

const initialState = {
    linkParams: {
        lang: '',
        uniquelink: '',
        uniquekey: '',
        environment: '',
        xpLang: '',
        pageName: '',
        modeId: ''
    }
};

const policySlice = createSlice({
    name: CommonStoreKey,
    initialState: initialState,
    reducers: {
        addLinkParamsInStore: (state, action) => ({
            ...state,
            linkParams: action.payload
        }),
        addAllRefPCPClinAndActonPopUpOpenInStore: (state, action) => ({
            ...state,
            AllRefPCPClinAndActonPopupValues: action.payload
        }),
        addAllRefPCPAndACtionPlanDetailsInStore: (state, action) => ({
            ...state,
            AllRefPcpAndActionPlanValues: action.payload
        })
    }
});

const { actions, reducer: commonReducer } = policySlice;
export const { addLinkParamsInStore, addAllRefPCPClinAndActonPopUpOpenInStore, addAllRefPCPAndACtionPlanDetailsInStore } = actions;
export default commonReducer;
